import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { SIGN_IN_PATH } from './app/auth.service';

// MSAL's hidden renewal iframe lands here; it only hands the response to the main page and must not start the app.
if (window.self !== window.top && window.location.pathname.startsWith(SIGN_IN_PATH)) {
  import('@azure/msal-browser/redirect-bridge')
    .then((bridge) => bridge.broadcastResponseToMainFrame())
    .catch((err) => console.error(err));
} else {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}
